<template>
  <input
    tabindex="-1"
    role="spinbutton"
    class="zm-simple-input-number"
    type="text"
    maxlength="2"
    :value="displayValue"
    :aria-valuenow="displayValue"
    :aria-valuetext="displayValue"
    :aria-valuemax="max"
    :aria-valuemin="min"
    @input="handleInput"
    @change="handleChange"
    @focus="handleFocus"
    @keydown.up.prevent="increase"
    @keydown.down.prevent="decrease"
    @keydown.home.prevent="home"
    @keydown.end.prevent="end"
  >
</template>

<script>
  import { padZero } from '../util'

  export default {
    name: 'simple-input-number',
    props: {
      value: Number | String,
      ranges: Array,
      default() {
        return [];
      }
    },
    data() {
      return {
        userInput: null,
        currentValue: 0
      }
    },
    computed: {
      max() {
        const ranges = this.ranges;
        return ranges[ranges.length - 1];
      },
      min() {
        const ranges = this.ranges;
        return ranges[0];
      },
      displayValue() {
        if (this.userInput !== null) {
          return this.userInput;
        }
        return padZero(this.currentValue)
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          let newVal = value === undefined ? value : Number(value);
          if (newVal !== undefined) {
            if (isNaN(newVal)) {
              return;
            }
          }
          const max = this.max;
          const min = this.min;
          if (newVal >= max) {
            newVal = max;
          }
          if (newVal <= min) {
            newVal = min;
          }
          this.currentValue = newVal;
          this.userInput = null;
          this.$emit('input', newVal);
        }
      }
    },
    methods: {
      handleFocus(e) {
        e.target.select();
      },
      handleInput(e) {
        this.userInput = e.target.value;
      },
      handleChange(e) {
        const value = e.target.value;
        const newVal = value === '' ? undefined : Number(value);
        if (!isNaN(newVal)) {
          this.setCurrentValue(newVal);
        }
        this.userInput = null;
      },
      setCurrentValue(newVal) {
        const oldVal = this.currentValue;
        const max = this.max;
        const min = this.min;
        if (newVal >= max) {
          newVal = max;
        }
        if (newVal <= min) {
          newVal = min;
        }
        if (oldVal === newVal) {
          return;
        }
        this.userInput = null;
        this.$emit('input', newVal);
        this.$emit('change', newVal, oldVal);
        this.currentValue = newVal;
      },
      increase() {
        const ranges = this.ranges;
        let currentIndex = ranges.indexOf(this.value);
        if (currentIndex === ranges.length - 1) {
          currentIndex = 0;
        } else {
          currentIndex++;
        }
        this.setCurrentValue(ranges[currentIndex]);
        this.$nextTick(() => {
          this.$el.select();
        });
      },
      home() {
        this.setCurrentValue(this.ranges[0]);
        this.$nextTick(() => {
          this.$el.select();
        });
      },
      end() {
        this.setCurrentValue(this.ranges[this.ranges.length - 1]);
        this.$nextTick(() => {
          this.$el.select();
        });
      },
      decrease() {
        const ranges = this.ranges;
        let currentIndex = ranges.indexOf(this.value);
        if (currentIndex === 0) {
          currentIndex = ranges.length - 1;
        } else {
          currentIndex--;
        }
        this.setCurrentValue(ranges[currentIndex]);
        this.$nextTick(() => {
          this.$el.select();
        });
      },
      focus() {
        const el = this.$el;
        el.setAttribute('tabindex', 0);
        el.focus();
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../scss/mixins/mixins";
  @import "../../../scss/common/var";

  @include b(simple-input-number) {
    border: none;
    outline: 0;
    width: 22px;
    line-height: 1;
  }
</style>
